import ApiService from "@/common/api/api.service";

export const ReportsService = {
  downloadBMRevenueCsv(bsId, startDate, endDate) {
    ApiService.setHeader();

    const params = new URLSearchParams({
      bsId: String(bsId),
      startDate,
      endDate
    });

    return ApiService.getFile(`bs/reports/bm-revenue-csv?${params.toString()}`);
  }
};
